import { createSlice } from '@reduxjs/toolkit'
import React from 'react'

const SkipToMainContentSlice = createSlice({
    name:'skip',
    initialState:{
        SkipButtonClicked:false
    },
    reducers:{
        skipClicked:(state)=>{
          state.SkipButtonClicked=true;
        },
        reset:(state)=>{
            state.SkipButtonClicked=false;
        }
    }
})

export const {skipClicked,reset} = SkipToMainContentSlice.actions;
export default SkipToMainContentSlice.reducer